
import { useIntl } from 'react-intl';
import UnsavedModal from '../UnsavedModal'
import PropTypes from 'prop-types';

const UnsavedChangesModal = ({ open, setOpen, handleCancel, handleDiscard }) => {
  const intl = useIntl();
  return (
    <UnsavedModal
      title={intl.formatMessage({
        id: "unsaved.title",
        defaultMessage: "Unsaved changes",
      })}
      subTitle={intl.formatMessage({
        id: "unsaved.subtitle",
        defaultMessage: "Are you sure you want to leave?",
      })}
      description={intl.formatMessage({
        id: "unsaved.description",
        defaultMessage:
          "You have unsaved changes. You can leave and discard the changes or cancel to continue editing.",
      })}
      open={open}
      setOpen={setOpen}
      okText={intl.formatMessage({
        id: "unsaved.discardchanges",
        defaultMessage: "Discard changes",
      })}
      canelText={intl.formatMessage({
        id: "label.cancel",
        defaultMessage: "Cancel",
      })}
      handleClose={handleCancel}
      handleDiscard={handleDiscard}
    />
  )
}
UnsavedChangesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleDiscard: PropTypes.func.isRequired,
};

export default UnsavedChangesModal